import {Source} from '../../generated/types';
import {humanJoin} from './human-join';
import {sourceBookToString} from '../enums';

export function getSourceText(source: Source[], basicRules?: boolean) {
	const text = source.map((source, index) => (
		<span key={index}>
			<i>«{sourceBookToString(source.book)}»</i>
			{(source.page || 0) > 0 && <>, стр. {source.page}</>}
		</span>
	));

	return humanJoin(text, ',');
}
